const init = () => {
  document.getElementById('toggle-navigation')
      .addEventListener('click', toggleNav, false);
  document.querySelectorAll('.js-nav-link').forEach((el) => {
    el.addEventListener('mouseover', displayImageOnHover, false);
  });
};

/* @this HTMLElement */
function toggleNav(event) {
  // Don't follow the link
  event.preventDefault();

  this.classList.toggle('is-active');
  const navigationEl = document.getElementById('navigation');
  navigationEl.classList.toggle('is-hidden');
  document.getElementById('header').classList.toggle('is-shy');
  document.body.classList.toggle('u-vp-no-scroll');

  // if menu has been hidden then reset preview images
  if(!navigationEl.classList.contains('is-active')) {
    navigationEl.querySelectorAll('.c-navigation__image').forEach(el =>
      el.classList.remove('is-visible'));

    navigationEl.querySelectorAll('.c-navigation__image--current').forEach(el =>
      el.classList.remove('is-hidden'));
  }
};

function displayImageOnHover() {
  const referenceID = this.dataset.target;

  // only show preview image for currently hovered nav link
  document.querySelectorAll('.c-navigation__image').forEach((el) => {
    el.dataset.referenceId === referenceID ?
      el.classList.add('is-visible') : el.classList.remove('is-visible');
  });

  // hide current page preview image
  document.querySelectorAll('.c-navigation__image--current').forEach(el =>
    el.classList.add('is-hidden'));
}

export default {init};